export default __webpack_public_path__ + "src/assets/coinbase.daefd968f77468b52746d6846c20e77c.svg";